import API_URLS from '@mgCommon/constants/api-urls.js';
import { INTERSTITIAL_TEMPLATE_CATEGORY } from '@mgCommon/constants/constants.js';
import axiosRestInstance from '@mgCommon/http/axios-rest-client.js';
import { getCbBaseURL, getCbVarible, prepareUrl } from '@mgCommon/utils/utils.js';

function restClientInstance() {
  const baseURL = getCbBaseURL();
  return axiosRestInstance({ baseURL });
}

function config(queryParams = {}) {
  const token = getCbVarible();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    params: queryParams,
    data: {},
  };
}

class TemplatesService {
  getByCategory({ category = null }) {
    const apiUrl = API_URLS.MESSAGE_TEMPLATES_PER_CATEGORY;
    const url = prepareUrl(apiUrl, {
      variable: '{category}',
      value: category,
    });
    return restClientInstance().get(url, config());
  }

  create({ template = null, category = null }) {
    const apiUrl =
      category === INTERSTITIAL_TEMPLATE_CATEGORY
        ? API_URLS.CREATE_INTERSTITIAL_TEMPLATE
        : API_URLS.CREATE_MESSAGE_TEMPLATE;
    return restClientInstance().post(apiUrl, template, config());
  }

  delete({ id = null, category = null }) {
    const apiUrl =
      category === INTERSTITIAL_TEMPLATE_CATEGORY
        ? API_URLS.DELETE_INTERSTITIAL_TEMPLATE
        : API_URLS.DELETE_MESSAGE_TEMPLATE;
    const url = prepareUrl(apiUrl, {
      variable: '{id}',
      value: id,
    });
    return restClientInstance().delete(url, config());
  }

  update({ id = null, template = null, category = null }) {
    const apiUrl =
      category === INTERSTITIAL_TEMPLATE_CATEGORY
        ? API_URLS.UPDATE_INTERSTITIAL_TEMPLATE
        : API_URLS.UPDATE_MESSAGE_TEMPLATE;
    const url = prepareUrl(apiUrl, {
      variable: '{id}',
      value: id,
    });
    return restClientInstance().put(url, template, config());
  }
}

export default new TemplatesService();
